'use client';

import React from 'react';
import { GoogleMap, Marker, StreetViewPanorama } from '@react-google-maps/api';
import { mapStyles } from '@/utils';
import useRWD from '@/hooks/useRWD';
import { useLoadGoogleMapsScript } from '@/hooks/useLoadGoogleMapsScript';
type Props = {
  initLocation: {
    lat: number;
    lng: number;
  };
};
const StreetView = ({
  initLocation: center
}: Props) => {
  const {
    isDesktop
  } = useRWD();
  const containerStyle = {
    width: '100%',
    height: isDesktop ? '100%' : '400px'
  };
  const {
    isLoaded: isMapLoaded
  } = useLoadGoogleMapsScript();
  return <div className="m-street-view mt-3 h-full w-full justify-between gap-x-5 lg:flex" data-sentry-component="StreetView" data-sentry-source-file="index.tsx">
      {isMapLoaded && <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={16} clickableIcons={false} options={{
      zoomControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      styles: mapStyles
    }}>
          <StreetViewPanorama options={{
        visible: true,
        position: center
      }} />
          <Marker icon={'/assets/svg/pin-jacknife.svg'} position={center} noClustererRedraw />
        </GoogleMap>}
    </div>;
};
export default StreetView;